// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Ww","up":"e_Xw","down":"e_Yw","percent":"e_Zw","percentVal":"e__w","title":"e_0w","tags":"e_1w","textBadge":"e_2w"};